// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid-module--grid--3Wxoq"};